import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Blaze } from '@dhl-ui/components'
import { AnnouncedChristmasIllustration } from '@dhl-ui/illustrations'
import { useGetProfileFirstname } from '~/profile/model/profile/hooks.js'
import { useSetTitle } from '~/setup/model/context.js'

export const Welcome: FC = () => {
  const { t } = useTranslation()
  const { data: firstname } = useGetProfileFirstname()

  useSetTitle(t('portal.profileSetup.welcome.pageTitle'))

  return (
    <Blaze
      description={t('portal.profileSetup.welcome.stepDescription')}
      slotProps={{ illustration: { variant: AnnouncedChristmasIllustration } }}
      sx={{ m: '20vh auto' }}
      title={t('portal.profileSetup.welcome.stepTitle', { name: firstname ? ` ${firstname}` : '' })}
    />
  )
}
